import {CANVAS_BLOC_ID} from '../../../../models/canvas-block-id';
import {Component, computed, input} from '@angular/core';
import {IackathonSave} from '../../../../services/iackathon-saves.service';
import {TranslateModule} from '@ngx-translate/core';

type CanvasEntry = {
    id: CANVAS_BLOC_ID;
    labelKey: `iackathon.${CANVAS_BLOC_ID}`;
    value: string | undefined;
};

@Component({
  selector: 'app-iackathon-step-canvas',
    imports: [
        TranslateModule
    ],
  templateUrl: './iackathon-step-canvas.component.html',
})
export class IackathonStepCanvasComponent {
    save = input.required<IackathonSave>();
    private state = computed(() => this.save()?.attributes.content.state);

    private readonly canvasBlockIds: CANVAS_BLOC_ID[] = ['need', 'target', 'stakeholders', 'aiPlace', 'uniqueValue', 'obstacles'];

    protected canvasEntries = computed<CanvasEntry[]>(() => {
        const canvas = this.state().odd_canvas_step;

        return this.canvasBlockIds.map((id) => ({
            id,
            labelKey: `iackathon.${id}`,
            value: canvas[id],
        }));
    });
}
